export function getNames(_) {
  return ['motion-fadeIn'];
}
export function web(options) {
  return style(options);
}
export function style(options) {
  const [fadeIn] = getNames(options);
  return [{
    ...options,
    name: fadeIn,
    easing: 'sineInOut',
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: 'var(--comp-opacity, 1)'
    }]
  }];
}
//# sourceMappingURL=FadeIn.js.map